export default __webpack_public_path__ + "static/media/vanessa.5fa18c6b.png";